import { useParams as useNavigationParams } from '#pplx/frontend/navigation/index.js';
import { useSpaRouteParams } from '#pplx/frontend/router/provider.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useMemo } from 'react';
export const useParams = () => {
    const pathname = usePathname();
    const sParams = useSpaRouteParams(pathname);
    const nParams = useNavigationParams();
    return useMemo(() => ({ ...(sParams ?? {}), ...nParams }), [sParams, nParams]);
};
//# sourceMappingURL=useParams.js.map